module.exports = __webpack_public_path__ + "static/media/Barfi.378acdfd.png";